// extracted by mini-css-extract-plugin
export default {"container":"eventcategory_container__CRDgY","wrapper":"eventcategory_wrapper__TNIJ9","mainbox":"eventcategory_mainbox__YwnDQ","content":"eventcategory_content__UULLf"};